<h2 mat-dialog-title class="src-titulo">
  @if (paso() === 'opciones' && tiposDisponibles.length > 1) {
    <button type="button" class="src-btn-volver" (click)="volver()" aria-label="Regresar">
      <mat-icon>arrow_back</mat-icon>
    </button>
  }
  <span>Selecciona un perfil</span>
  <button type="button" class="src-btn-refresh" (click)="actualizarContextos()"
          [disabled]="cargando()" matTooltip="Actualizar roles disponibles">
    @if (cargando()) {
      <mat-spinner diameter="16" />
    } @else {
      <mat-icon>refresh</mat-icon>
    }
  </button>
</h2>

<mat-dialog-content class="src-contenido">

  @if (paso() === 'tipo') {
    <p class="src-subtitulo">Tienes varios tipos de acceso. ¿Cómo quieres ingresar?</p>

    <div class="src-tipos-grid">
      @if (globales.length) {
        <button type="button" class="src-tipo-card" (click)="elegirTipo('global')">
          <mat-icon>public</mat-icon>
          <span>Global</span>
        </button>
      }
      @if (ligas.length) {
        <button type="button" class="src-tipo-card" (click)="elegirTipo('liga')">
          <mat-icon svgIcon="tt_trofeo"></mat-icon>
          <span>Liga</span>
        </button>
      }
      @if (equipos.length) {
        <button type="button" class="src-tipo-card" (click)="elegirTipo('equipo')">
          <mat-icon svgIcon="tt_equipos"></mat-icon>
          <span>Equipo</span>
        </button>
      }
    </div>
  }

  @if (paso() === 'opciones') {

    @switch (tipoSeleccionado()) {

      @case ('global') {
        <p class="src-subtitulo">Elige tu rol</p>
        <div class="src-roles-flat">
          @for (ctx of globales; track ctx.rol) {
            <button type="button" class="src-rol-btn" (click)="elegirContexto(ctx)">{{ ctx.rol }}</button>
          }
        </div>
      }

      @case ('liga') {
        <p class="src-subtitulo">Elige tu liga y rol</p>
        <div class="src-grupos-grid">
          @for (liga of ligas; track liga.id) {
            <div class="src-grupo-card">
              <div class="src-grupo-logo">
                @if (liga.logo && !logoConError(liga.id)) {
                  <img [src]="liga.logo" [alt]="liga.nombre" (error)="onLogoError(liga.id)">
                } @else {
                  <mat-icon svgIcon="tt_trofeo"></mat-icon>
                }
              </div>
              <span class="src-grupo-nombre">{{ liga.nombre | uppercase }}</span>
              <div class="src-roles-compact">
                @for (ctx of liga.contextos; track ctx.rol) {
                  <button type="button" class="src-rol-chip" (click)="elegirContexto(ctx)">{{ ctx.rol }}</button>
                }
              </div>
            </div>
          }
        </div>
      }

      @case ('equipo') {
        <p class="src-subtitulo">Elige tu equipo y rol</p>

        @if (equipos.length <= maxEquiposEnGrid) {
          <div class="src-grupos-grid">
            @for (equipo of equipos; track equipo.id) {
              <div class="src-grupo-card">
                <div class="src-grupo-logo">
                  @if (equipo.logo && !logoConError(equipo.id)) {
                    <img [src]="equipo.logo" [alt]="equipo.nombre" (error)="onLogoError(equipo.id)">
                  } @else {
                    <mat-icon svgIcon="tt_equipos"></mat-icon>
                  }
                </div>
                <span class="src-grupo-nombre">{{ equipo.nombre | uppercase }}</span>
                <div class="src-roles-compact">
                  @for (ctx of equipo.contextos; track ctx.rol) {
                    <button type="button" class="src-rol-chip" (click)="elegirContexto(ctx)">{{ ctx.rol }}</button>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <mat-form-field appearance="outline" class="src-equipo-select">
            <mat-label>Equipo y rol</mat-label>
            <!-- Una opción por equipo y rol: quien tiene dos roles en un equipo lo ve dos veces y entra directo con el que elija. -->
            <mat-select (selectionChange)="elegirContexto($event.value)">
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="equipoFiltroControl"
                  placeholderLabel="Buscar equipo..."
                  noEntriesFoundLabel="No se encontraron equipos">
                </ngx-mat-select-search>
              </mat-option>
              @for (equipo of equiposFiltrados; track equipo.id) {
                @for (ctx of equipo.contextos; track ctx.rol) {
                  <mat-option [value]="ctx">
                    <span class="src-opcion-equipo">{{ equipo.nombre | uppercase }}</span>
                    <span class="src-opcion-rol">{{ ctx.rol }}</span>
                  </mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
        }
      }

    }

  }

</mat-dialog-content>
